var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExamCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16964",
    "data-name": "Group 16964",
    transform: "translate(-1058 -439)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_218",
    "data-name": "Ellipse 218",
    cx: 53.5,
    cy: 53.5,
    r: 53.5,
    transform: "translate(1058 439)",
    fill: "#f4f7fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Exam_-_Flaticon-2",
    "data-name": "Search results for Exam - Flaticon-2",
    transform: "translate(1069.5 463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10408",
    "data-name": "Group 10408",
    transform: "translate(16.5 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3328",
    "data-name": "Path 3328",
    d: "M270.084,274a13.584,13.584,0,1,0,13.7,13.584A13.6,13.6,0,0,0,270.084,274Zm4.169,11.94-4.566,5.479a1.712,1.712,0,0,1-2.847-.33l-1.826-3.653a1.712,1.712,0,0,1,3.063-1.531l.656,1.311,2.89-3.468a1.712,1.712,0,1,1,2.631,2.192Z",
    transform: "translate(-229.104 -242.723)",
    fill: "#4807e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3329",
    "data-name": "Path 3329",
    d: "M56.742,9.755,49.795,2.57l-.01-.01A8.617,8.617,0,0,0,43.678,0H21.637A5.143,5.143,0,0,0,16.5,5.137v44.4a5.143,5.143,0,0,0,5.137,5.137H43.6A17,17,0,0,1,57.48,27.853q.867,0,1.712.085V15.751a8.512,8.512,0,0,0-2.45-6ZM34.65,38.24H25.518a1.712,1.712,0,0,1,0-3.425H34.65a1.712,1.712,0,1,1,0,3.425Zm0-9.132H25.518a1.712,1.712,0,1,1,0-3.425H34.65a1.712,1.712,0,1,1,0,3.425Zm0-9.132H25.518a1.712,1.712,0,1,1,0-3.425H34.65a1.712,1.712,0,1,1,0,3.425Zm10.958,9.132H43.782a1.712,1.712,0,1,1,0-3.425h1.826a1.712,1.712,0,1,1,0,3.425Zm0-9.132H43.782a1.712,1.712,0,0,1,0-3.425h1.826a1.712,1.712,0,1,1,0,3.425Z",
    transform: "translate(-16.5 0)",
    fill: "#4807e6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamCat);
export default __webpack_public_path__ + "static/media/examCat.0eb5c391e96db2075b1b5071e36f2bfb.svg";
export { ForwardRef as ReactComponent };